export const COLORS = {
	bg: "#F5F3EF",
	surface: "#FFFFFF",
	border: "#E2DDD6",
	borderStrong: "#C8C0B4",
	text: "#1C1917",
	textMuted: "#78716C",
	textLight: "#A8A29E",
	// Champ verrouillé (disabled / readonly) : fond et texte atténués, uniformes
	// sur les 3 fiches (cf. components/styles/ficheVerrouillee.css).
	disabledBg: "#EFEDE8",
	disabledText: "#57534E",
	accent: "#2563EB",
	accentLight: "#EFF6FF",
	danger: "#DC2626",
	dangerLight: "#FEF2F2",
	dangerBorder: "#FECACA",
	success: "#16A34A",
	successLight: "#F0FDF4",
	warning: "#D97706",
	warningLight: "#FFFBEB",
	gold: "#B45309",
	perteBg: "rgba(220, 38, 38, 0.05)",
	perteBorder: "rgba(254, 202, 202, 0.6)",
	perteHeaderBg: "rgba(220, 38, 38, 0.04)",
}

// Hauteur de la barre de nav (NavV2). Elle est dans le flux au-dessus des pages :
// une page en `100vh` déborderait donc de cette hauteur → scroll vertical parasite.
// Toute page pleine hauteur doit déduire NAV_HEIGHT (cf. generalStyles.page).
export const NAV_HEIGHT = 58

// Styles du modal V2 (CustomModal). Consomme les tokens COLORS ci-dessus —
// seules les couleurs alpha (overlay, ombres) restent en rgba littéral.
export const modalStyles = {
	overlay: {
		position: "fixed",
		inset: 0,
		backgroundColor: "rgba(28, 25, 23, 0.5)",
		backdropFilter: "blur(4px)",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		zIndex: 1000,
		padding: 24,
	},
	modal: {
		backgroundColor: COLORS.surface,
		borderRadius: 20,
		border: `1px solid ${COLORS.border}`,
		boxShadow: "0 24px 48px rgba(28, 25, 23, 0.15)",
		width: "100%",
		maxWidth: 560,
		maxHeight: "90vh",
		overflow: "hidden",
		display: "flex",
		flexDirection: "column",
	},
	header: {
		padding: "20px 24px",
		borderBottom: `1px solid ${COLORS.border}`,
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
	},
	title: {
		fontSize: 16,
		fontWeight: 600,
		color: COLORS.text,
		letterSpacing: "-0.01em",
	},
	subtitle: {
		fontSize: 14,
		color: COLORS.textMuted,
		marginTop: 5,
	},
	closeBtn: {
		width: 32,
		height: 32,
		borderRadius: 8,
		border: `1px solid ${COLORS.border}`,
		backgroundColor: "transparent",
		color: COLORS.textMuted,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		cursor: "pointer",
		fontSize: 18,
		fontWeight: 300,
	},
	body: {
		padding: "20px 24px",
		overflowY: "auto",
		flex: 1,
	},
	footer: {
		padding: "16px 24px",
		borderTop: `1px solid ${COLORS.border}`,
		display: "flex",
		justifyContent: "flex-end",
		gap: 10,
		backgroundColor: COLORS.bg,
	},
	btnSecondary: {
		padding: "9px 18px",
		borderRadius: 10,
		border: `1px solid ${COLORS.border}`,
		backgroundColor: COLORS.surface,
		color: COLORS.text,
		fontSize: 13,
		fontWeight: 500,
		cursor: "pointer",
		fontFamily: "inherit",
	},
	btnPrimary: {
		padding: "9px 20px",
		borderRadius: 10,
		border: "none",
		backgroundColor: COLORS.text,
		color: "#fff",
		fontSize: 13,
		fontWeight: 500,
		cursor: "pointer",
		fontFamily: "inherit",
	},
	btnDisabled: {
		padding: "9px 20px",
		borderRadius: 10,
		border: "none",
		backgroundColor: COLORS.border,
		color: COLORS.textLight,
		fontSize: 13,
		fontWeight: 500,
		cursor: "not-allowed",
		fontFamily: "inherit",
	},
	btnDanger: {
		padding: "9px 18px",
		borderRadius: 10,
		border: `1px solid ${COLORS.dangerBorder}`,
		backgroundColor: COLORS.dangerLight,
		color: COLORS.danger,
		fontSize: 13,
		fontWeight: 500,
		cursor: "pointer",
		fontFamily: "inherit",
	},
}

export const LOCATION_ETAT_RESERVATION = 0
export const LOCATION_ETAT_ETAT_DES_LIEUX = 1
export const LOCATION_ETAT_EN_COURS = 2
export const LOCATION_ETAT_RESTITUE = 3
export const LOCATION_ETAT_A_FACTURER = 4
export const LOCATION_ETAT_ATTENTE_PAIEMENT = 5
export const LOCATION_ETAT_CLOS = 6
export const LOCATION_ETAT_CHOICES = [
	[LOCATION_ETAT_RESERVATION, "Réservé"],
	[LOCATION_ETAT_ETAT_DES_LIEUX, "Prêt pour l'état des lieux"],
	[LOCATION_ETAT_EN_COURS, "En location"],
	[LOCATION_ETAT_RESTITUE, "Restitué"],
	[LOCATION_ETAT_A_FACTURER, "A facturer"],
	[LOCATION_ETAT_ATTENTE_PAIEMENT, "En attente de paiement"],
	[LOCATION_ETAT_CLOS, "Clos"],
]
export const LOCATION_ETAT_DICT = Object.fromEntries(LOCATION_ETAT_CHOICES)
